var map = {
	"./amadeus.png": "e23f",
	"./confluent.png": "37bd",
	"./hkcs.png": "110d",
	"./hkstpsaa.png": "454e",
	"./ibm.png": "0215",
	"./mulesoft.png": "d993",
	"./new-relic.png": "d5c5",
	"./softwareag.png": "d4b6b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "af36";